export default __webpack_public_path__ + "images/0xaaa6c1e32c55a7bfa8066a6fae9b42650f262418.png";